import {
  createAdditionalParticipant,
  removeAdditionalParticipant,
  selectAdditionalParticipant,
  getAvailableAdditionalParticipants,
} from '../services/invite_additional_participant.service';

const ADD_NEW_PARTICIPANT = 'ADD_NEW_PARTICIPANT';
const ADDED_NEW_PARTICIPANT = 'ADDED_NEW_PARTICIPANT';
const SELECT_PARTICIPANT = 'SELECT_PARTICIPANT';
const ADDED_SELECTED_PARTICIPANT = 'ADDED_SELECTED_PARTICIPANT';
const REMOVE_PARTICIPANT = 'REMOVE_PARTICIPANT';
const REMOVED_PARTICIPANT = 'REMOVED_PARTICIPANT';
const RESET_PARTICIPANT_FORM = 'RESET_PARTICIPANT_FORM';
const GET_AVAILABLE_PARTICIPANTS_LIST = 'GET_AVAILABLE_PARTICIPANTS_LIST';
const UPDATE_AVAILABLE_PARTICIPANTS_LIST = 'UPDATE_AVAILABLE_PARTICIPANTS_LIST';

const events = [
  ADDED_NEW_PARTICIPANT,
  ADDED_SELECTED_PARTICIPANT,
  ADD_NEW_PARTICIPANT,
  SELECT_PARTICIPANT,
  REMOVED_PARTICIPANT,
  REMOVE_PARTICIPANT,
  RESET_PARTICIPANT_FORM,
  GET_AVAILABLE_PARTICIPANTS_LIST,
  UPDATE_AVAILABLE_PARTICIPANTS_LIST,
];

const PURCHASERS_EMAIL = {
  'ADDITIONAL_PURCHASER': $('#additional-purchaser-primary-purchaser-email'),
  'FUNDS_PROVIDER': $('#funds-provider-primary-purchaser-email'),
  'DIRECTOR': $('#director-primary-purchaser-email'),
  'SHAREHOLDER': $('#shareholder-primary-purchaser-email'),
}


const initializeEventListeners = () => {
  EVENT_BUS.registerEvents(events);

  EVENT_BUS.on(SELECT_PARTICIPANT, ({ id, type, auctionId, csrfToken }) => {
    const onError = (err) => console.warn(err);
    const onResponse = (response) => {
      if (response.status === 201) {
        const { id, first_name, last_name, email, link_type } = response.data;
        EVENT_BUS.dispatch(ADDED_SELECTED_PARTICIPANT, {
          id,
          type: link_type,
          firstName: first_name,
          lastName: last_name,
          email,
        });
      }
    };
    selectAdditionalParticipant({
      id,
      type,
      csrfToken,
      auctionId,
      onResponse,
      onError,
    });
  });

  EVENT_BUS.on(
    ADD_NEW_PARTICIPANT,
    ({ firstName, lastName, type, email, auctionId, csrfToken }) => {
      const onError = (err) => {
        if (
          err.response.status === 400 &&
          err.response.data.hasOwnProperty('__all__') &&
          err.response.data['__all__'].includes('primary-purchaser-email')
        ) {
          const { link_type } = JSON.parse(err.response.config.data);
          PURCHASERS_EMAIL[link_type].removeClass('d-none');
        }
      };
      const onResponse = (response) => {
        if (response.status === 201) {
          const { id, first_name, last_name, email, link_type } = response.data;
          EVENT_BUS.dispatch(ADDED_NEW_PARTICIPANT, {
            id,
            type: link_type,
            firstName: first_name,
            lastName: last_name,
            email,
          });
          PURCHASERS_EMAIL[link_type].addClass('d-none');
          EVENT_BUS.dispatch(RESET_PARTICIPANT_FORM, {
            type: link_type,
          });
        }
      };
      createAdditionalParticipant({
        firstName,
        lastName,
        email,
        type,
        auctionId,
        csrfToken,
        onResponse,
        onError,
      });
    }
  );

  EVENT_BUS.on(REMOVE_PARTICIPANT, ({ type, id, csrfToken, auctionId }) => {
    const onError = (err) => console.warn(err);
    const onResponse = (response) => {
      if (response.status === 202) {
        const { id, link_type } = response.data;
        EVENT_BUS.dispatch(REMOVED_PARTICIPANT, { type: link_type, id });
      }
    };
    removeAdditionalParticipant({
      id,
      type,
      auctionId,
      csrfToken,
      onResponse,
      onError,
    });
  });

  EVENT_BUS.on(
    GET_AVAILABLE_PARTICIPANTS_LIST,
    ({ csrfToken, auctionInCartId }) => {
      const onError = (err) => console.warn(err);
      const onResponse = (response) => {
        if (response.status === 200) {
          const { available_additional_participants } = response.data;
          EVENT_BUS.dispatch(UPDATE_AVAILABLE_PARTICIPANTS_LIST, {
            available_additional_participants,
          });
        }
      };
      getAvailableAdditionalParticipants({
        auctionInCartId,
        csrfToken,
        onResponse,
        onError,
      });
    }
  );
};

export const ADDITIONAL_PARTICIPANT_EVENTS = {
  ADDED_NEW_PARTICIPANT,
  ADDED_SELECTED_PARTICIPANT,
  ADD_NEW_PARTICIPANT,
  SELECT_PARTICIPANT,
  REMOVED_PARTICIPANT,
  REMOVE_PARTICIPANT,
  RESET_PARTICIPANT_FORM,
  GET_AVAILABLE_PARTICIPANTS_LIST,
  UPDATE_AVAILABLE_PARTICIPANTS_LIST,
  initializeEventListeners,
};
